module.exports = __webpack_public_path__ + "static/media/002.609ac90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/002.jpg
// module id = 475
// module chunks = 0